import { Grid, GridItem, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MinimalOrgDto } from "../../../autogen/bff-api";
import { useOrganizationProfileUrls } from "../useOrganizationProfileUrls";
import { SearchResult } from "./SearchResult";
import styles from "./SearchResults.module.css";

interface Props {
  organizations?: MinimalOrgDto[];
  isSearching: boolean;
  count?: number;
}

export const SearchResults = ({ organizations, isSearching, count }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const profileUrls = useOrganizationProfileUrls();

  return (
    <Grid gridTemplateColumns={"1fr"} gridTemplateRows="minmax(50px, 1fr)" gridAutoRows={"minmax(100px, auto)"}>
      <GridItem display="flex" alignItems={"center"}>
        <Text fontSize="md" marginLeft={4}>
          {organizations && (
            <>
              <b>{count}</b> {t("companies found")}{" "}
            </>
          )}
        </Text>
        {isSearching && <Spinner ml="8px" size={"xs"} />}
      </GridItem>

      {organizations ? (
        organizations.map((o) => (
          <GridItem
            key={o.id}
            className={styles.result}
            py="5"
            onClick={() => {
              if (o.type === "OrganizationEntry") {
                navigate(profileUrls.goToEntry(o.id, profileUrls.sections.information));
              } else {
                navigate(profileUrls.go(o.id, profileUrls.sections.information));
              }
            }}
          >
            <SearchResult organization={o} />
          </GridItem>
        ))
      ) : (
        <div>{t("Loading")}...</div>
      )}
    </Grid>
  );
};
